import script from "./AggregatesCrusherRecommender.vue?vue&type=script&lang=js"
export * from "./AggregatesCrusherRecommender.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__